export default __webpack_public_path__ + "assets/new_entities_verify_icon-845981877f7ec17e5da14de7f77c34f5.png";